import React from 'react';
import { Plus, Search, Sparkles, Calendar } from 'lucide-react';
import WheelIcon from '../../../../components/icons/WheelIcon';

interface WheelsPageHeaderProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  onCreateClick: () => void;
  onAIClick: () => void;
  wheelType: 'instant' | 'scheduled';
  onTypeChange: (type: 'instant' | 'scheduled') => void;
}

const WheelsPageHeader: React.FC<WheelsPageHeaderProps> = ({
  searchTerm,
  onSearchChange,
  onCreateClick,
  onAIClick,
  wheelType,
  onTypeChange
}) => {
  const tabBase = 'px-4 py-2 rounded-md text-sm font-bold inline-flex items-center gap-2 transition-colors';
  const tabActive = 'bg-bordo text-creme shadow-sm';
  const tabInactive = 'text-tinta-soft hover:text-bordo';

  return (
    <>
      {/* Header */}
      <div className="sm:flex sm:items-end sm:justify-between gap-4">
        <div>
          <h1 className="font-display text-3xl font-black text-tinta leading-tight">
            Seus <span className="italic text-bordo">sorteios</span>
          </h1>
          <p className="mt-2 text-sm text-tinta-soft">
            Gerencie seus sorteios e configure os produtos disponíveis
          </p>
        </div>
        <div className="mt-4 sm:mt-0 flex flex-col sm:flex-row gap-2">
          <button
            onClick={onAIClick}
            className="w-full sm:w-auto inline-flex items-center justify-center px-4 py-2.5 rounded-lg text-sm font-bold text-tinta bg-mostarda hover:bg-mostarda-light border border-mostarda-dark/30 transition-colors"
          >
            <Sparkles className="mr-2 h-4 w-4" />
            Criar com IA
          </button>
          <button
            onClick={onCreateClick}
            className="w-full sm:w-auto inline-flex items-center justify-center px-4 py-2.5 rounded-lg text-sm font-bold text-creme bg-bordo hover:bg-bordo-dark transition-colors"
          >
            <Plus className="mr-2 h-4 w-4" />
            Novo Sorteio
          </button>
        </div>
      </div>

      {/* Wheel Type Tabs — pill-style */}
      <div>
        <div className="inline-flex bg-creme border border-tinta/15 rounded-lg p-1">
          <button
            onClick={() => onTypeChange('instant')}
            className={`${tabBase} ${wheelType === 'instant' ? tabActive : tabInactive}`}
          >
            <WheelIcon className="h-4 w-4" />
            Rodas Instantâneas
          </button>
          <button
            onClick={() => onTypeChange('scheduled')}
            className={`${tabBase} ${wheelType === 'scheduled' ? tabActive : tabInactive}`}
          >
            <Calendar className="h-4 w-4" />
            Sorteios Agendados
          </button>
        </div>
      </div>

      {/* Search Bar */}
      <div className="relative">
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <Search className="h-5 w-5 text-tinta-soft" />
        </div>
        <input
          type="text"
          className="block w-full pl-10 pr-3 py-2.5 bg-white border border-tinta/15 rounded-lg text-sm text-tinta placeholder:text-tinta-soft/70 placeholder:italic focus:outline-none focus:ring-2 focus:ring-bordo/40 focus:border-bordo transition-colors"
          placeholder="Buscar roda de prêmios..."
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
        />
      </div>
    </>
  );
};

export default WheelsPageHeader;
